module.exports = __webpack_public_path__ + "img/call.1c6367ba.svg";